import React from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: 'What are your store hours?',
      answer: 'We are open daily from 9:00 AM to 9:00 PM, including weekends and holidays.'
    },
    {
      question: 'Do you offer local pickup?',
      answer: 'Yes! Local pickup is FREE. Simply select Local Pickup at checkout and pick up your order at our store: 6575 E Livingston Ave, Reynoldsburg, OH 43068.'
    },
    {
      question: 'What is your shipping policy?',
      answer: 'We offer flat rate shipping of $7.99. Orders over $75 qualify for FREE shipping!'
    },
    {
      question: 'What is your return policy?',
      answer: 'We accept returns within 14 days of purchase. Items must be in original condition with tags attached. Please contact us to initiate a return.'
    },
    {
      question: 'Do you sell authentic Nepali products?',
      answer: 'Yes! We specialize in authentic Nepali clothing, jewelry, and accessories. Our sarees, traditional wear, and jewelry are carefully selected for quality and cultural authenticity.'
    },
    {
      question: 'What payment methods do you accept?',
      answer: 'We accept all major credit and debit cards, Apple Pay, and Google Pay through our secure Stripe payment gateway.'
    },
    {
      question: 'Can I order online and pick up in store?',
      answer: 'Absolutely! This is one of our most popular options. Choose Local Pickup at checkout and we will notify you when your order is ready for pickup.'
    },
    {
      question: 'Do you have items under $10?',
      answer: 'Yes! Check our $1-$10 Deals category for amazing bargains on quality accessories, beauty products, and more.'
    },
    {
      question: 'Can I track my order?',
      answer: 'Yes, once your order ships, you will receive a tracking number via email.'
    },
    {
      question: 'Do you sell gift cards?',
      answer: 'Please contact us at the store or via email for gift card inquiries.'
    }
  ];

  return (
    <div className="min-h-screen bg-white" data-testid="faq-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1
          className="text-4xl sm:text-5xl font-bold mb-8 text-center"
          style={{ fontFamily: 'Playfair Display, serif' }}
          data-testid="faq-title"
        >
          Frequently Asked Questions
        </h1>

        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b pb-6" data-testid={`faq-item-${index}`}>
              <h2 className="text-xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                {faq.question}
              </h2>
              <p className="text-gray-700">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 bg-gray-100 rounded-lg text-center">
          <h3 className="text-xl font-bold mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
            Still have questions?
          </h3>
          <p className="text-gray-600 mb-4">We are here to help!</p>
          <a
            href="/contact"
            className="inline-block bg-[#D4AF37] text-white py-3 px-8 rounded-full hover:bg-[#B5952F] transition-colors"
            data-testid="contact-us-button"
          >
            Contact Us
          </a>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
